// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__mw7XZ","opacity-transition":"error_opacity-transition__AtVJZ"};